module.exports = {
    expired_1: "Tautan kedaluwarsa",
    limit_time: "Penawaran waktu terbatas untuk ",
    participate: "Ikuti acara ulasan sekarang untuk klaim hadiah eksklusif Anda!",
    exclusive: "Eksklusif",
    reward: "Hadiah",
    token: "Token",
    vip: "Hari VIP",
    after_completing: "Setelah menyelesaikan ulasan dan verifikasi screenshot, Anda akan menerima",
    step_1: "<strong style='color: #000000'>Klik tombol di bawah</strong> untuk mengunjungi toko aplikasi dan <strong style='color: #000000'>beri ulasan 5 bintang.</strong>",
    step_2: "Setelah menyelesaikan ulasan, silakan <strong style='color: #000000'>ambil screenshot</strong> konten ulasan Anda.",
    step_3: "<strong style='color: #000000'>Unggah screenshot</strong> di bawah ini dan kirimkan ID dalam aplikasi Anda untuk menerima hadiah.",
    click_to: "1. Klik untuk pergi ke ",
    upload: "2. Unggah Screenshot Ulasan",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "Pergi ke ",
    example: "Contoh screenshot",
    upload_screenshot: "Unggah Screenshot",
    claim: "Klaim Hadiah",
    verification_inprogress: "Terima kasih atas unggahan Anda. Screenshot Anda sedang ditinjau secepat mungkin. Harap bersabar.",
    verification_success: "Selamat! <br/><br/> Anda telah berhasil mengklaim hadiah Anda. Hadiah akan dikreditkan ke akun Anda <strong>dalam waktu 24 jam.</strong> Harap ditunggu. <br/><br/> Jika Anda memiliki pertanyaan, jangan ragu untuk menghubungi dukungan pelanggan.",
    verification_failed: "Screenshot ulasan harus memenuhi kondisi berikut: <br/><br/> <div style='margin-left: 6px'> 1.Rating harus 5 bintang dan konten harus positif. <br/><br/> 2.Ulasan harus dibuat di <strong> Apple App Store atau Google Play Store. </strong> <br/><br/> 3.Screenshot harus menampilkan konten ulasan secara lengkap, termasuk <strong> avatar, nama pengguna, dan teks ulasan. <strong></div>",
    reupload: "Unggah ulang",
}